module.exports = __webpack_public_path__ + "static/media/contact-logo.3d7e8271.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/contact-logo.svg
 ** module id = 1299
 ** module chunks = 0
 **/